import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const ExamplesSection = () => {
  const examples = [
    {
      title: 'Event Flyers',
      description: 'Dynamically generated event flyers with personalized details',
      imagePlaceholder: 'event-flyer'
    },
    {
      title: 'Brochures',
      description: 'Custom and personalized brochures on demand',
      imagePlaceholder: 'product-catalog'
    },
    {
      title: 'Social Media Graphics',
      description: 'Social media graphics with personalized and dynamic content',
      imagePlaceholder: 'social-media'
    },
    {
      title: 'Certificates',
      description: 'Professional certificates and awards with recipient details',
      imagePlaceholder: 'certificate'
    },
  ];
  
  return (
    <section className="section" id="examples">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Create More with Less Effort</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Turn one Adobe InDesign template into thousands of unique, ready-to-use outputs — from marketing materials to certificates and beyond.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {examples.map((example, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 bg-gray-200 flex items-center justify-center">
                {/* Placeholder for example images */}
                <div className="text-center p-8">
                  <div className="inline-block rounded-full bg-primary bg-opacity-10 p-4 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <p className="text-gray-500">{example.imagePlaceholder} preview</p>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2">{example.title}</h3>
                <p className="text-gray-600 mb-4">{example.description}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="inline-block w-3 h-3 bg-green-500 rounded-full mr-2"></span>
                    Print & Digital Ready
                  </div>
                  {/* Placeholder for example pages 
                  <Link href={`/examples/${example.title.toLowerCase().replace(' ', '-')}`} className="text-primary hover:underline font-medium">
                    View Example →
                  </Link>*/}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExamplesSection;
